import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ACTOR_VOICES_QUERY_KEYS } from "Actors/Api/Queries/actorVoicesQueryKeys";
import {
  type GenerateActorVoicePreviewRequest,
  postActorsActorIDActorVoicesActorVoiceIDGeneratePreview,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";

interface GeneratePreviewParams {
  actorVoiceID: string;
  request: GenerateActorVoicePreviewRequest;
}

export function useGenerateActorVoicePreviewMutation(actorID: string) {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(
    ({ actorVoiceID, request }: GeneratePreviewParams) =>
      postActorsActorIDActorVoicesActorVoiceIDGeneratePreview(
        request,
        actorID,
        actorVoiceID,
      ),
    {
      translationPrefix: getResourcePath(
        Resources.ApiErrors.GenerateActorVoicePreview,
      ),
    },
  );

  return useMutation({
    mutationFn,
    onSuccess: (_, { actorVoiceID }) => {
      queryClient.invalidateQueries({
        queryKey: ACTOR_VOICES_QUERY_KEYS.detail(actorID, actorVoiceID),
      });
      queryClient.invalidateQueries({
        queryKey: ACTOR_VOICES_QUERY_KEYS.list(actorID),
      });
    },
  });
}
